import classNames from "classnames";

import { DotIndicator } from "./DotIndicator";

import styles from "./StrengthIndicator.module.scss";

type StrengthIndicatorProps = {
  name: string;
  strength: number;
  isLarge?: boolean;
  className?: string;
};

export const StrengthIndicator = ({ name, strength, isLarge = false, className }: StrengthIndicatorProps) => {
  return (
    <div className={classNames(styles.strengthIndicator, { [styles.large]: isLarge }, className)}>
      <span className={classNames(styles.strengthIndicatorTitle, { [styles.large]: isLarge })}>{name}</span>
      <DotIndicator strength={strength} isLarge={isLarge} />
    </div>
  );
};
